import { useEffect, useState } from "react";

export const useDimension = (): { width: number; height: number } => {
  const getDefaultSize = () => {
    if (typeof window === "undefined") {
      return { width: 0, height: 0 };
    }
    return { width: window.innerWidth, height: window.innerHeight };
  };
  const defaultSize = getDefaultSize();
  const [width, setWidth] = useState(defaultSize.width);
  const [height, setHeight] = useState(defaultSize.height);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return {
    width,
    height,
  };
};

export default useDimension;
